import {
  FILE_MANAGER_MATCH_MODE,
  FILE_MANAGER_PAGE_SIZE,
  SORT_BY,
  SORT_DIRECTION,
} from './utils';

const createDetailEntitySearchState = () => ({
  data: [],
  loading: false,
  error: null,
  searchRequestId: 0,
});

export const createBulkLinkModalInitialState = () => ({
  itemIds: [],
  mode: 'link',
  linkedEntities: {
    linkedContacts: [],
    linkedProperties: [],
    linkedDevelopments: [],
  },
  properties: createDetailEntitySearchState(),
  developments: createDetailEntitySearchState(),
  contacts: createDetailEntitySearchState(),
  saveStatus: 'idle',
});

export const createDetailModalInitialState = () => ({
  itemId: null,
  itemType: null,
  item: null,
  linkedEntities: {
    linkedContacts: [],
    linkedProperties: [],
    linkedDevelopments: [],
  },
  locationTrail: [],
  status: 'idle',
  linkedEntitiesStatus: 'idle',
  error: null,
  properties: createDetailEntitySearchState(),
  developments: createDetailEntitySearchState(),
  contacts: createDetailEntitySearchState(),
  entityActionStatus: 'idle',
  updateItemStatus: 'idle',
  updateItemErrorKey: null,
  updateItemField: null,
});

const initialState = {
  viewMode: 'list',
  viewPreferenceDirty: false,
  selectedIds: [],
  currentFolderId: null,
  folderTrail: [],
  items: [],
  total: 0,
  page: 1,
  pageSize: FILE_MANAGER_PAGE_SIZE,
  listStatus: 'idle',
  isOpeningFolderFromFilters: false,
  sortBy: SORT_BY.UPLOAD_DATE,
  sortDirection: SORT_DIRECTION.DESC,
  searchQuery: '',
  uploadedBy: [],
  uploadDateRange: [null, null],
  linkedContacts: [],
  linkedProperties: [],
  linkedDevelopments: [],
  matchMode: FILE_MANAGER_MATCH_MODE.ANY,
  isCreateFolderModalOpen: false,
  createFolderStatus: 'idle',
  renameItem: null,
  previewItem: null,
  renameStatus: 'idle',
  renameErrorKey: null,
  moveItem: null,
  moveStatus: 'idle',
  deleteItems: null,
  deleteStatus: 'idle',
  detailModal: createDetailModalInitialState(),
  bulkLinkModal: createBulkLinkModalInitialState(),
};

export default initialState;
